import { Badge, ThemeCss } from "gatsby-interface"
import { MdFlashOn } from "react-icons/md"
import { BurstIcon } from "./BurstIcon"

export default function BurstBuildChip() {
  return (
    <Badge
      tone="NEUTRAL"
      Icon={BurstIcon}
      textVariant="DEFAULT"
      css={burstBadgeCss}
    >
      Burst
    </Badge>
  )
}

// const badgeCss: ThemeCss = theme => ({
//   display: `flex`,
//   marginLeft: theme.space[7],
//   "& > *": {
//     marginRight: theme.space[3],
//   },
// })

const burstBadgeCss: ThemeCss = _theme => ({
  border: "1px solid #DBF0FF",
  background: "#F5FCFF",
})
